import { render } from "./Gallery.vue?vue&type=template&id=3b46ea20&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=ts"
export * from "./Gallery.vue?vue&type=script&lang=ts"

import "./Gallery.vue?vue&type=style&index=0&id=3b46ea20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b46ea20"

export default script